import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  private isBrowser: boolean;
  secretKey = 'Q&)qj3YQs=RPHV~E51RP9xHkBlr9$1J7';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  // Método para encriptar datos
  encrypt(data: string): string {
    return CryptoJS.AES.encrypt(data, this.secretKey).toString();
  }

  // Método para desencriptar datos
  decrypt(encryptedData: string) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log(error)
      return '';
    }
  }

  // Método para guardar datos encriptados en sessionStorage
  setItem(key: string, value: string): void {
    try {
      const encryptedValue = this.encrypt(value);
      if (this.isBrowser) {
        sessionStorage.setItem(key, encryptedValue);
      }
    } catch (error) {
      console.log(error)
    }
  }

  // Método para obtener y desencriptar datos de sessionStorage
  getItem(key: string): string {
    if (this.isBrowser) {
      const encryptedValue = sessionStorage.getItem(key);
      if (encryptedValue) {
        return this.decrypt(encryptedValue);
      }
    }
    return '';
  }

  clear() {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.log(error);
    }
  }
}